export const MASTER_ALLERGY_EDIT_FIELDS ={
    NAME:"name",
    CATEGORY: 'category',
    REACTION:"reaction",
    ACTION:"action",
}

export const MASTER_MEDICATION_EDIT_FIELDS ={
    NAME:"name",
    TYPE: 'type',
}